import { createContext, useContext } from "react";
import type { SubagentEvent } from "~/components/assistant-v2/SubagentActivity";
import type { McpAppEntry } from "~/components/assistant-v2/useMcpAppEvents";

// Subagent events context — provided by the conversation runtime, consumed by
// DefaultToolMessage to render real-time progress inside parent tool cards.
const EMPTY_MAP = new Map<string, SubagentEvent[]>();
const SubagentEventsContext = createContext<Map<string, SubagentEvent[]>>(EMPTY_MAP);

export const SubagentEventsProvider = SubagentEventsContext.Provider;

export function useSubagentEventsForTool(toolCallId: string): SubagentEvent[] {
  const map = useContext(SubagentEventsContext);
  return map.get(toolCallId) ?? [];
}

// MCP App UI events context — provided by the conversation runtime, consumed by
// DefaultToolMessage to render inline MCP App iframes for tool calls.
const EMPTY_MCP_MAP = new Map<string, McpAppEntry>();
const McpAppEventsContext = createContext<Map<string, McpAppEntry>>(EMPTY_MCP_MAP);

export const McpAppEventsProvider = McpAppEventsContext.Provider;

export function useMcpAppFrameForTool(toolCallId: string): McpAppEntry | undefined {
  const map = useContext(McpAppEventsContext);
  return map.get(toolCallId);
}

export function useAllMcpAppEntries(): Map<string, McpAppEntry> {
  return useContext(McpAppEventsContext);
}
